module.exports = __webpack_public_path__ + "static/media/2_pl.4ee80c54.png";